export default __webpack_public_path__ + "static/assets/863a431f5a841f808062267464196e29.png";